import { useRef } from "react";

import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrDeleteButton from "UI/FnrDeleteButton";
import FnrTextLink from "UI/FnrTextLink";
import FnrTypography from "UI/FnrTypography";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";

import useIsHoverFocused from "Utilities/Hooks/useIsHoverFocused";
import stopEvents from "Utilities/stopEvents";

import { useFnrUploadButtonContext } from "../../FnrUploadButton";
import { useClear, useShowDelete, useWithValueText } from "../../stateHooks";
import DisplayContainer from "../DisplayContainer";

const WithValueDisplay = () => {
  const clear = useClear();
  const {
    color,
    compact,
    confirmDelete,
    href,
    readOnly,
    typographyProps,
    hideDelete,
    underlineOnHover,
    showDownloadIcon,
    showCheckIcon,
  } = useFnrUploadButtonContext();
  const showDelete = useShowDelete();

  const withValueText = useWithValueText();

  const deleteRef = useRef();
  const deleteButtonIsHoverFocused = useIsHoverFocused(deleteRef);

  return (
    <DisplayContainer>
      <FnrHorizontalGap gap={8} centered>
        <FnrTypography
          breakWord
          color="textBlack"
          fontSize={compact ? "xs" : "md"}
          {...typographyProps}
        >
          <FnrTextLink
            underlineOnHover={underlineOnHover}
            href={href}
            color={typographyProps.color}
          >
            {withValueText}
          </FnrTextLink>
        </FnrTypography>
        {showDownloadIcon && (
          <FnrContainedIcon icon="cloud-download fas" noPadding />
        )}
        {showCheckIcon && (
          <FnrContainedIcon
            icon="fa-check-circle fas"
            color="completed"
            noPadding
          />
        )}
        {!readOnly && !hideDelete && (
          <div onClick={stopEvents}>
            <FnrDeleteButton
              variant="iconButton"
              show={Boolean(showDelete || deleteButtonIsHoverFocused)}
              onClick={clear}
              color={color}
              ref={deleteRef}
              size={compact ? "sm" : "md"}
              confirmText={
                confirmDelete
                  ? "Are you sure you want to delete this file? This cannot be undone."
                  : undefined
              }
            />
          </div>
        )}
      </FnrHorizontalGap>
    </DisplayContainer>
  );
};

export default WithValueDisplay;
